// @ts-nocheck

class SockCarousel {
  constructor() {
    this.rootSelector = '[data-sock-carousel]';
    this.setupCarousels();
    document.addEventListener('shopify:section:load', () => this.setupCarousels());
  }

  setupCarousels() {
    const rootEls = document.querySelectorAll(this.rootSelector);
    rootEls.forEach((rootEl) => {
      if (rootEl.dataset.isReady === 'true') return;
      rootEl.dataset.isReady = 'true';
      this.setupCarousel(rootEl);
    });
  }

  setupCarousel(rootEl) {
    const trackEl = rootEl.querySelector('[data-sock-track]');
    const slideEls = rootEl.querySelectorAll('[data-sock-slide]');
    const dotBtns = rootEl.querySelectorAll('[data-sock-dot]');
    if (!trackEl || !dotBtns.length) return;

    let isTicking = false;
    trackEl.addEventListener('scroll', () => {
      if (isTicking) return;
      isTicking = true;
      requestAnimationFrame(() => {
        this.updateDots(trackEl, dotBtns);
        isTicking = false;
      });
    }, { passive: true });

    dotBtns.forEach((dotBtn, dotIndex) => {
      dotBtn.addEventListener('click', () => this.onDotClick(trackEl, slideEls, dotBtns, dotIndex));
    });

    window.addEventListener('resize', () => this.updateDots(trackEl, dotBtns));
    this.updateDots(trackEl, dotBtns);
  }

  getDotIndex(trackEl, scrollLeft, dotCount) {
    const maxScroll = trackEl.scrollWidth - trackEl.clientWidth;
    if (maxScroll <= 0) return 0;
    return Math.round((scrollLeft / maxScroll) * (dotCount - 1));
  }

  getSnapPositions(trackEl, slideEls) {
    const maxScroll = trackEl.scrollWidth - trackEl.clientWidth;
    const firstLeft = slideEls[0].offsetLeft;
    const positions = [];
    slideEls.forEach((slideEl) => {
      const position = Math.min(Math.round(slideEl.offsetLeft - firstLeft), Math.round(maxScroll));
      if (!positions.includes(position)) positions.push(position);
    });
    return positions;
  }

  onDotClick(trackEl, slideEls, dotBtns, dotIndex) {
    if (!slideEls.length) return;

    const positions = this.getSnapPositions(trackEl, slideEls);
    let targetPosition = positions[0];
    let closestGap = Infinity;
    positions.forEach((position) => {
      const gap = Math.abs(this.getDotIndex(trackEl, position, dotBtns.length) - dotIndex);
      if (gap < closestGap) {
        closestGap = gap;
        targetPosition = position;
      }
    });

    trackEl.scrollTo({ left: targetPosition, behavior: 'smooth' });
  }

  updateDots(trackEl, dotBtns) {
    const activeIndex = this.getDotIndex(trackEl, trackEl.scrollLeft, dotBtns.length);
    dotBtns.forEach((dotBtn, index) => {
      const isActive = index === activeIndex;
      dotBtn.classList.toggle('is-active', isActive);
      dotBtn.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

new SockCarousel();
